import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h4 {...{
      "id": "ℹ️-can-we-use-a-greedy-algorithm",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#%E2%84%B9%EF%B8%8F-can-we-use-a-greedy-algorithm",
        "aria-label": "ℹ️ can we use a greedy algorithm permalink",
        "className": "autolink-header before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`ℹ️ Can we use a greedy algorithm?`}</h4>
    <p>{`Initially, I thought the problem could be solved with a greedy algorithm: just choose the highest number in each column. However, I found that a greedy algorithm didn’t always produce the optimal sum. I couldn’t choose multiple cells in the same row, because that would give multiple clusters the same color. Thus, greedily choosing a cell in one column could lock me out of choosing the highest number in a subsequent column.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      